<template>
    <div
      :id="id"
      class="card"
      :draggable="draggable"
      :resizable="resizable"
      @dragstart="dragstart"
      @dragover.stop
>
      <slot />
    </div>
</template>



<script>
export default {
  props: ['id', 'draggable'],
  methods: {
    dragstart: e => {
      const target = e.target;

      e.dataTransfer.setData('card_id', target.id);

      setTimeout(() => {
        target.style.display = "none";
      }, 0);
    }
  }
}
</script>




<style>

.card {
  background: rgba(16, 22, 58, 0.3);
  outline-color: #42da91;
  color: #fff;
}
</style>
